import { GridColDef } from '@mui/x-data-grid-pro';
import { DeductionRecord } from '@api/Trinium/Endpoints/Settlements/types';
import { negativeAmountClass } from '../gridStyles';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

/** Deductions are reported negative, so every money column can turn red. */
const currencyColumn = {
  type: 'number' as const,
  valueFormatter: (value: number | undefined) => (value != null ? currencyFormatter.format(value) : ''),
  cellClassName: ({ value }: { value?: number }) => (value != null && value < 0 ? negativeAmountClass : '')
};

export const columns: GridColDef<DeductionRecord>[] = [
  { field: 'serviceCode', headerName: 'Service Code', width: 130 },
  { field: 'serviceDescription', headerName: 'Service Description', minWidth: 200, flex: 1 },
  { field: 'deductionType', headerName: 'Type', width: 110 },
  { field: 'originalAmount', headerName: 'Original Amount', width: 140, ...currencyColumn },
  { field: 'amountThisWeek', headerName: 'Amount this Week', width: 150, ...currencyColumn },
  { field: 'previouslyCollected', headerName: 'Previously Collected', width: 160, ...currencyColumn },
  { field: 'total', headerName: 'Total', width: 120, ...currencyColumn },
  { field: 'remaining', headerName: 'Remaining', width: 120, ...currencyColumn },
  { field: 'deductionNotes', headerName: 'Deduction Notes', minWidth: 260, flex: 1.5 }
];
